module.exports = __webpack_public_path__ + "static/media/StylishCalligraphy.54d8170b.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/StylishCalligraphy.ttf
// module id = 1456
// module chunks = 40